import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, getBooleanTypeAttr, getNumTypeAttr, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { CssTransition, _arrow, _Popper } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var STATEKEY = 'tooltipState';
var DEFAULTDELAY = 80;
var EnterCls = 'zoom-big-fast-enter';
var LeaveCls = 'zoom-big-fast-leave';
var CssTransitonCommonConfig = {
    rmCls: true,
    timeout: 80,
    enterCls: EnterCls,
    leaveCls: LeaveCls
};
var VISIBLETIMER, EVENTTIMER;
var Tooltip = /** @class */ (function () {
    function Tooltip() {
        this.VERSION = 'v2.0';
        this.COMPONENTS = $el('r-tooltip', { all: true });
        this._create(this.COMPONENTS);
        _arrow.scrollUpdate();
    }
    Tooltip.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'tooltip');
        var _a = Tooltip.prototype, _attrs = _a._attrs, _setAlwaysShow = _a._setAlwaysShow, _handleMouseEv = _a._handleMouseEv;
        var _b = _attrs(target), delay = _b.delay, always = _b.always, disabled = _b.disabled, offset = _b.offset, placement = _b.placement;
        var TooltipPopper = target.querySelector("." + PREFIX.tooltip + "-popper");
        var TooltipInner = target.querySelector("." + PREFIX.tooltip + "-inner");
        return {
            get content() {
                return setHtml(TooltipInner);
            },
            set content(newVal) {
                if (newVal && !type.isStr(newVal) && !type.isNum(newVal))
                    return;
                setHtml(TooltipInner, "" + newVal);
            },
            get always() {
                return always;
            },
            set always(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                _setAlwaysShow(TooltipPopper, newVal);
            },
            get disabled() {
                return disabled;
            },
            set disabled(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                _handleMouseEv(target, TooltipPopper, delay, offset, placement, this.always, newVal);
            },
            events: function (_a) {
                var onVisibleChange = _a.onVisibleChange;
                var event = function () {
                    var visable = TooltipPopper.dataset[STATEKEY] === 'show';
                    onVisibleChange && type.isFn(onVisibleChange, visable);
                };
                var show = function () {
                    if (EVENTTIMER)
                        clearTimeout(EVENTTIMER);
                    EVENTTIMER = setTimeout(event, delay);
                };
                var close = function () {
                    if (EVENTTIMER)
                        clearTimeout(EVENTTIMER);
                    // 当鼠标移出tooltip后判断当前状态如果为 show，
                    // 那么说明气泡显示过了，该执行移出事件了。
                    // 避免了即使鼠标移出但没有显示过气泡而依然执行事件。
                    if (TooltipPopper.dataset[STATEKEY] === 'show')
                        setTimeout(event, DEFAULTDELAY);
                };
                bind(target, 'mouseenter', show);
                bind(target, 'mouseleave', close);
            }
        };
    };
    Tooltip.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), content = _a.content, theme = _a.theme, placement = _a.placement, offset = _a.offset, maxWidth = _a.maxWidth, delay = _a.delay, always = _a.always, disabled = _a.disabled;
            var children = !node.firstElementChild
                ? node.innerHTML.trim()
                : node.firstElementChild;
            _this._setMainTemplate(node, content, theme, placement);
            var TooltipPopper = node.querySelector("." + PREFIX.tooltip + "-popper");
            _this._setReferencesElem(node, children);
            _this._setPopper(node, TooltipPopper, placement, offset);
            _this._setMaxWidth(node, maxWidth);
            _this._setAlwaysShow(TooltipPopper, always);
            _this._handleMouseEv(node, TooltipPopper, delay, offset, placement, always, disabled);
            removeAttrs(node, ['content', 'theme', 'delay', 'max-width', 'disabled', 'offset']);
        });
    };
    Tooltip.prototype._setMainTemplate = function (node, content, theme, placement) {
        var template = "\n         <div class=\"" + PREFIX.tooltip + "-rel\"></div>\n         <div class=\"" + PREFIX.tooltip + "-popper " + PREFIX.tooltip + "-" + theme + "\" x-placement=\"" + placement + "\">\n             <div class=\"" + PREFIX.tooltip + "-content\">\n                 <div class=\"" + PREFIX.tooltip + "-arrow\"></div>\n                 <div class=\"" + PREFIX.tooltip + "-inner\">" + content + "</div>\n             </div>\n         </div>\n       ";
        setHtml(node, template);
    };
    Tooltip.prototype._setReferencesElem = function (node, children) {
        var TooltipRel = node.querySelector("." + PREFIX.tooltip + "-rel");
        if (children instanceof Element) {
            TooltipRel.appendChild(children);
        }
        else {
            setHtml(TooltipRel, children);
        }
    };
    Tooltip.prototype._setMaxWidth = function (node, width) {
        if (!width)
            return;
        var TooltipInner = node.querySelector("." + PREFIX.tooltip + "-inner");
        TooltipInner.classList.add(PREFIX.tooltip + "-with-width");
        setCss(TooltipInner, 'maxWidth', width + "px");
    };
    Tooltip.prototype._setAlwaysShow = function (children, always) {
        if (!always)
            setCss(children, 'display', 'none');
        children.dataset[STATEKEY] = 'pending';
    };
    Tooltip.prototype._handleMouseEv = function (node, children, delay, offset, placement, always, disabled) {
        var _this = this;
        if (always || disabled)
            return;
        var setVisable = function (mode) {
            if (mode === 'in')
                _this._setPopper(node, children, placement, offset);
            children.dataset[STATEKEY] = mode === 'in' ? 'show' : 'close';
            CssTransition(children, __assign({ inOrOut: mode }, CssTransitonCommonConfig));
        };
        var show = function () {
            if (VISIBLETIMER)
                clearTimeout(VISIBLETIMER);
            VISIBLETIMER = setTimeout(function () { return setVisable('in'); }, delay);
        };
        var hide = function () {
            if (VISIBLETIMER)
                clearTimeout(VISIBLETIMER);
            if (children.dataset[STATEKEY] === 'show')
                setTimeout(function () { return setVisable('out'); }, DEFAULTDELAY);
        };
        bind(node, 'mouseenter', show);
        bind(node, 'mouseleave', hide);
    };
    Tooltip.prototype._setPopper = function (node, children, placement, offset) {
        return _Popper._newCreatePopper(node, children, placement, offset);
    };
    Tooltip.prototype._attrs = function (node) {
        return {
            theme: getStrTypeAttr(node, 'theme', 'dark'),
            content: getStrTypeAttr(node, 'content', ''),
            maxWidth: getStrTypeAttr(node, 'max-width', ''),
            placement: getStrTypeAttr(node, 'placement', 'top'),
            delay: getNumTypeAttr(node, 'delay', DEFAULTDELAY),
            offset: getNumTypeAttr(node, 'offset', 0),
            always: getBooleanTypeAttr(node, 'always'),
            disabled: getBooleanTypeAttr(node, 'disabled')
        };
    };
    return Tooltip;
}());
export default Tooltip;
